import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/produto.msg'

class AtendimentosService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('atendimentos', msg)
  }
}

export default new AtendimentosService()
